import React from 'react';
import {
  ProductContainer,
  ProductData,
  ProductCfn,
  Quantity,
  TypeText,
  Description,
  Brands,
  BrandsName,
} from './index.styled.jsx';
import { useTranslation } from 'react-i18next';

const MobileProductCard = ({ item, index, handleSetItemClick }) => {
  const { t } = useTranslation();

  return (
    <ProductContainer
      key={index}
      borderTop={
        index === 0 &&
        '1px solid var(--borders-lines-medium, #0000004D)'
      }
      borderBottom={
        item.isLast &&
        '1px solid var(--borders-lines-medium, #0000004D)'
      }
    >
      <ProductData>
        <ProductCfn
          id={`item-cfn-${item.productCFN || item.cfn || item.bom || index}`}
          onClick={() => handleSetItemClick(item)}
        >
          {item.productCFN || item.cfn || item.bom}
        </ProductCfn>
        <Quantity>
          {item.quantity} × <TypeText>{item.uom}</TypeText>
        </Quantity>
      </ProductData>
      <Description>{item.description}</Description>
      {item.brand && (
        <Brands>
          {t('scheduleSurgery.surgery.notifications.itemListView.brand')}
          :<BrandsName>{`\u00A0${item.brand}`}</BrandsName>
        </Brands>
      )}
    </ProductContainer>
  );
};

export default MobileProductCard;